import TYPES from '../../action-types';
import sdk from '../../../sdk';

/**
 * Get indexing status for visual search for collection
 * @param {string} collectionID
 */
function getIndexingStatusForVisualSearch(collectionID) {
  return async (dispatch) => {
    dispatch({
      type: TYPES.COLLECTIONS.GET_INDEXING_STATUS_FOR_VISUAL_SEARCH.START,
      payload: { collectionID },
    });

    try {
      const { data } = await sdk.assets.checkIndexingStatusForVisualSearch(
        collectionID,
      );
      if (data && data.indexedAssetsCount === undefined) {
        throw new Error('Indexed assets count is undefined');
      }
      if (data && data.notIndexedAssetsCount === undefined) {
        throw new Error('Not indexed assets count is undefined');
      }
      dispatch({
        type: TYPES.COLLECTIONS.GET_INDEXING_STATUS_FOR_VISUAL_SEARCH.COMPLETE,
        payload: {
          collectionID,
          indexedAssetsCount: data.indexedAssetsCount,
          notIndexedAssetsCount: data.notIndexedAssetsCount,
        },
      });
    } catch (error) {
      dispatch({
        type: TYPES.COLLECTIONS.GET_INDEXING_STATUS_FOR_VISUAL_SEARCH.FAILED,
        payload: {
          collectionID,
        },
      });
    }
  };
}

export default getIndexingStatusForVisualSearch;
